import { SelectListValueType } from 'complex-data/src/data/SelectList'
import systemApi from '../api/system'
import ComplexSelect from '@/class/ComplexSelect'

export interface ComplexSelectValueType extends SelectListValueType<any> {
  [prop: string]: any
}

export const serviceProviderSelect = new ComplexSelect<ComplexSelectValueType>({
  name: '服务商',
  enable: true,
  list: [],
  getData() {
    return new Promise((resolve, reject) => {
      systemApi.serviceProviderList.require({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        const list = res.data.data.map((item: any) => {
          item.value = item.id
          item.label = item.serviceName
          item.$filter = [item.enableFlag === 1 ? 'enable' : 'disabled']
          return item
        })
        resolve({ status: 'success', list })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
})

export const parkingPointSelect = new ComplexSelect<ComplexSelectValueType>({
  name: '停车点',
  enable: true,
  list: [],
  getData() {
    return new Promise((resolve, reject) => {
      systemApi.parkingPointList.require({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        const list = res.data.data.map((item: any) => {
          item.value = item.id
          item.label = item.parkPointName
          item.$filter = [item.status === 1 ? 'enable' : 'disabled']
          return item
        })
        resolve({ status: 'success', list })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
})
